<template>
  <div class="container-fluid">
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-info"></i> لیست درخواست های استرداد سپرده
          <span class="float-left" @click="$router.go(-1)">
            <i
              data-v-9331d9a2=""
              title="بازگشت به صفحه قبلی"
              class="fas fa-arrow-left text-light Pointer"
              style="float: left; font-size: 18px"
            ></i
          ></span>
        </h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12">
            <div class="letter-request-results">
              <div class="letter-request-cards" dir="rtl">
                <p v-if="!rows.length" class="letter-request-cards__empty">
                  موردی برای نمایش وجود ندارد
                </p>
                <template v-else>
                <div class="letter-request-cards__toolbar">
                  <input
                    v-model="cardSearch"
                    type="search"
                    class="form-control letter-request-cards__search"
                    placeholder=" جستجو"
                    aria-label="جستجو در درخواست‌ها"
                  />
                  <button
                    type="button"
                    class="letter-request-export-btn"
                    title="Excel"
                    aria-label="دانلود Excel"
                    @click="Download"
                  >
                    <i class="fas fa-file-excel" aria-hidden="true"></i>
                  </button>
                </div>
                <p
                  v-if="filteredCardRows.length === 0"
                  class="letter-request-cards__empty"
                >
                  اطلاعاتی یافت نشد
                </p>
                <div v-else class="letter-request-cards__list">
                  <article
                    v-for="(row, index) in pagedCardRows"
                    :key="(row.id || 'row') + '-' + index"
                    class="letter-request-card"
                  >
                    <div class="letter-request-card__header">
                      <strong class="letter-request-card__name">{{
                        row.namFam
                      }}</strong>
                      <span
                        class="letter-request-card__badge"
                        :class="
                          'letter-request-card__badge--' + letterStatus(row)
                        "
                        >{{ letterStatusLabel(row) }}</span
                      >
                    </div>
                    <div
                      v-if="row.mablaghSeporde != null && row.mablaghSeporde !== ''"
                      class="letter-request-card__amount"
                    >
                      <span dir="ltr">{{
                        $Comma3ragham(row.mablaghSeporde)
                      }}</span>
                      <small>{{ $GetVahedPool() }}</small>
                    </div>
                    <div class="letter-request-card__fields">
                      <div
                        v-if="row.codeMeli"
                        class="letter-request-card__field"
                      >
                        <span>کد ملی</span>
                        <strong dir="ltr">{{ row.codeMeli }}</strong>
                      </div>
                      <div
                        v-if="row.zamanInsert"
                        class="letter-request-card__field"
                      >
                        <span>تاریخ درخواست</span>
                        <strong>{{ row.zamanInsert }}</strong>
                      </div>
                      <div
                        v-if="row.shomareHesab"
                        class="letter-request-card__field"
                      >
                        <span>شماره حساب</span>
                        <strong dir="ltr">{{ row.shomareHesab }}</strong>
                      </div>
                      <div class="letter-request-card__field">
                        <span>تاریخ امتیاز</span>
                        <strong>{{ letterScoreDateText(row) }}</strong>
                      </div>
                    </div>
                    <div
                      v-if="row.vaziatGrp44 == null"
                      class="letter-request-card__action"
                    >
                      <select
                        class="form-control Pointer letter-request-card__select"
                        v-model="Combo44"
                        @change="ChangeCombo44(row)"
                      >
                        <option :value="-1">در حال بررسی</option>
                        <option :value="7190">تاییـــد شد</option>
                        <option :value="7191">رد شــــد</option>
                      </select>
                    </div>
                  </article>
                </div>
                <div
                  v-if="filteredCardRows.length > cardPerPage"
                  class="letter-request-cards__pager"
                >
                  <button
                    type="button"
                    class="letter-request-cards__pager-btn"
                    :disabled="cardPage <= 1"
                    @click="cardPage = cardPage - 1"
                  >
                    قبلی
                  </button>
                  <span class="letter-request-cards__pager-info">
                    صفحه {{ cardPage }} از {{ cardPageCount }}
                  </span>
                  <button
                    type="button"
                    class="letter-request-cards__pager-btn"
                    :disabled="cardPage >= cardPageCount"
                    @click="cardPage = cardPage + 1"
                  >
                    بعدی
                  </button>
                </div>
                </template>
              </div>
              <div class="letter-request-table-view">
                <vue-bootstrap4-table
                  :rows="rows"
                  :columns="columns"
                  :config="config"
                  :classes="classes"
                  :actions="actions"
                  @on-download="Download"
                >
                  <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                  </template>
                  <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                  </template>
                  <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                  </template>
                  <template slot="mablaghSeporde" slot-scope="props">
                    {{ $Comma3ragham(props.row.mablaghSeporde) }}
                  </template>
                  <template slot="tarixEmatiazVam" slot-scope="props">
                    {{
                      props.row.tarixEmatiazVam == null
                        ? "امتیاز ذخیره گردد "
                        : " تا تاریخ " +
                          props.row.tarixEmatiazVam +
                          " محاسبه گردد "
                    }}
                  </template>
                  <template slot="Action" slot-scope="props">
                    <select
                      class="form-control Pointer"
                      v-model="Combo44"
                      @change="ChangeCombo44(props.row)"
                      v-if="props.row.vaziatGrp44 == null"
                    >
                      <option :value="-1">در حال بررسی</option>
                      <option :value="7190">تاییـــد شد</option>
                      <option :value="7191">رد شــــد</option>
                    </select>
                    <div v-else>
                      <span
                        class="badge badge-success px-2 font-weight-normal"
                        v-if="props.row.vaziatGrp44 == 7190"
                      >
                        تاییـــد شد
                      </span>
                      <span
                        class="badge badge-danger px-2 font-weight-normal"
                        v-if="props.row.vaziatGrp44 == 7191"
                      >
                        رد شــــد
                      </span>
                    </div>
                  </template>
                  <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                  </template>
                </vue-bootstrap4-table>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-12 mt-3">
            <ExcelExport
              :data="exceltable"
              worksheet-name="Sheet1"
              @success="handleExcelSuccess"
              @error="handleExcelError"
            >
              <button class="btn btn-outline-success d-none">
                <i
                  class="fas fa-file-excel btn btn-outline-success Pointer d-none"
                  id="DownloadExcel"
                >
                  دانلود فایل اکسل
                </i>
              </button>
            </ExcelExport>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import letterRequestCards from "@/utils/letterRequestCards";
export default {
  components: { NetPaCard, VueBootstrap4Table },
  mixins: [letterRequestCards],
  data() {
    return {
      CodeMeli: "",
      rows: [],
      exceltable: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },

        {
          label: "مشخصات ",
          name: "namFam",
        },
        {
          label: "کد ملی",
          name: "codeMeli",
        },
        {
          label: "تاریخ درخواست",
          name: "zamanInsert",
          sort: true, // "false" by default
          initial_sort: true, // "false" by default
          initial_sort_order: "desc",
        },

        {
          label: "شماره حساب",
          name: "shomareHesab",
        },
        {
          label: "مبلغ استرداد",
          name: "mablaghSeporde",
        },
        {
          label: "تاریخ امتیاز",
          name: "tarixEmatiazVam",
        },
        {
          label: "عملیات",
          name: "Action",
          sort: true, // "false" by default
          initial_sort: true, // "false" by default
          initial_sort_order: "desc",
        },
      ],
      actions: [
        {
          btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
          event_name: "on-download",
          class: "btn  mx-2 btn-outline-success rounded btnEXL ",
          event_payload: {
            msg: "my custom msg",
          },
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page: 100,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      Combo44: -1,
    };
  },
  mounted() {
    this.CodeMeli = this.$session.get("UserInfoNetPa").codeMeli.trim();
    this.GetData();
    this.GetCombo44();
  },
  methods: {
    GetData() {
      var formdata = new FormData();
      var DataAxios_GetData = {
        ArryfildValue: {},
        Method: "Get",
        Action: "Letter/GetSodorEsterdad",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios_GetData).then((data) => {
        if (data.length) {
          let info;
          let list = [];
          if (data.length > 10) {
            this.config.pagination = true;
          } else {
            this.config.pagination = false;
          }
          for (let index = 0; index < data.length; index++) {
            info = data[index];
            list.push(info);
          }
          this.rows = list;
          this.exelReport(this.rows);
        } else {
          this.config.pagination = false;
        }
      });
    },
    Download() {
      document.getElementById("DownloadExcel").click();
    },
    exelReport(rows) {
      this.exceltable = [];
      rows.forEach((element) => {
        // console.log(element);
        var excelrow = {
          مشخصات: element.namFam,
          "کد ملی": element.codeMeli,
          "تاریخ درخواست": element.zamanInsert,
          "شماره حساب": element.shomareHesab,
          "مبلغ استرداد": element.mablaghSeporde,
          "تاریخ امتیاز": element.tarixEmatiazVam,
        };

        this.exceltable.push(excelrow);
      });
    },
    GetCombo44() {
      let action = "ComboGrp/44";
      this.$PostData_new(action, "get").then((res) => {
        // console.log("🤦🏻‍♂️ ~ file: ListRequestLetterSodorEsterdad.vue:187 ~ res:", res)
      });
    },
    ChangeCombo44(row) {
      if (this.Combo44 == -1) {
        return;
      } else {
        this.$SweetQustion(
          "اطمینان از تغییر وضعیت ",
          "از تغییر وضعیت درخواست اطمینان دارید ؟",
          "question",
          "تایید ",
          "انصراف",
          row,
          this.PutData,
          this.isNotConfirmed,
        );
      }
    },
    PutData(row) {
      let DataAxios = {
        ArryfildValue: {},
        Method: "post",
        Action: "Letter/PutSodorEsterdad",
        Token: this.$session.get("TokenNetPa"),
      };
      row.vaziatGrp44 = this.Combo44;
      DataAxios.ArryfildValue = row;
      this.$PostData(DataAxios).then((res) => {
        if (res == true) {
          this.$mySweetDefaultTost(
            "عملیات موفق",
            "تغییر وضعیت درخواست با موفقیت انجام شد",
            "success",
            2000,
          );
          this.GetData();
        }
      });
    },
  },
};
</script>
<style scoped></style>
